import React from 'react'
import PageLayout from 'components/pages/PageLayout'

import PageError from 'components/pages/PageError'

export type Props = {
  message: React.JSX.Element | string
  children?: React.JSX.Element | string
}

const ErrorPage = ({ message, children }: Props) => (
  <PageLayout staticPage>
    <div className="min-h-72">
      {message && (
        <PageError style={{ minHeight: '18rem' }}>{message}</PageError>
      )}
      {children}
    </div>
  </PageLayout>
)

export default ErrorPage
